// 格式化时间(两种)
const dateFormat = {
  // 解决时间戳毫秒级
  wayOne: (datetime, fmt) => {
    let date = new Date(datetime)
    if (!fmt || fmt === 'default') {
      //默认格式 或 没传格式
      fmt = "YYYY-mm-dd HH:MM:SS"
    }
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
    };
    return fmt;

    // 用法（已全局引用）
    // let date = new Date()
    // this.$formatTime.wayOne(date,"YYYY-mm-dd HH:MM:SS")
    // >>> 2019-06-06 19:45:00`
  },
  wayTwo: (date) => {
    //解决 2020-02-22T16:00:00.000Z 格式的时间
    function addZero(num) {
      return num < 10 ? '0' + num : num;
    }
    const time = new Date(Date.parse(date));
    //判断是否需要加8个时区，默认不加
    // time.setTime(time.setHours(time.getHours() + 8));
    const Y = time.getFullYear() + '-';
    const M = addZero(time.getMonth() + 1) + '-';
    const D = addZero(time.getDate()) + ' ';
    const h = addZero(time.getHours()) + ':';
    const m = addZero(time.getMinutes()) + ':';
    const s = addZero(time.getSeconds());
    return Y + M + D + h + m + s;

    // 用法（已全局引用）
    // let date = new Date()
    // this.$formatTime.wayTwo(date)
    // >>> 2019-06-06 19:45:00`
  },
  wayThree: (date, fmt) => {
    // 兼容ios 安卓的格式化 解决 2020-02-22T16:00:00.000Z 格式的时间
    if (date == null || date == '' || date == 'undefined') {
      return '';
    }
    date = date + '';
    date = date.replace(/\-/g, "/");
    if (date.indexOf('GMT') == -1) {
      date = date.replace(/\T/g, " ");
    }
    if (date.indexOf('.') != -1) {
      date = date.substr(0, date.indexOf('.'));
    }
    date = new Date(date);
    fmt = fmt || "yyyy-MM-dd hh:mm:ss";
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S": date.getMilliseconds() //毫秒   
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }
}

export default dateFormat;
